import { IWizardStep, TWizard } from "src/ui/Wizard/wizardTypes"

export function getNumberOfSteps(steps: IWizardStep[]) {
  return steps.filter((s) => {
    if (s.skip) {
      return false
    }

    if (s.hideProgress) {
      return false
    }

    return true
  }).length
}

export function getProgressBarValue({
  currentStep,
  steps,
}: Pick<TWizard, "currentStep" | "steps">) {
  const visibleNbrSteps = getNumberOfSteps(steps)
  return clamp({ num: (currentStep / visibleNbrSteps) * 100, min: 5, max: 100 })
}

function clamp({ num, min, max }: { num: number; min: number; max: number }) {
  return Math.min(Math.max(num, min), max)
}
